import { useSelector } from 'react-redux';
import cn from 'classnames';
import { isMobileLayout } from 'components/Shared/responsive';
import DesktopMenu from './desktop';
import MobileMenu from './mobile';
import styles from './styles.scss';

interface Props {
  className?: string;
}

const MainMenu = ({ className }: Props) => {
  const isMobile = useSelector(isMobileLayout);

  return (
    <div className={cn(styles.mainMenu, className)}>
      {isMobile ? <MobileMenu /> : <DesktopMenu />}
    </div>
  );
};

export default MainMenu;
